import { gql, useLazyQuery } from '@apollo/client';

const today = new Date().toISOString();

const query = gql`
query ($tag: String, $per_page: Int, $excluding_ids: String) {
    NewsItems(first_published_at_lt:"${today}", sort_by: "first_published_at:desc", with_tag: $tag, per_page: $per_page,  excluding_ids: $excluding_ids) {
        total
        items {
            id
            uuid
            name
            slug
            full_slug
            published_at
            first_published_at
            tag_list
            content {
                hat
                custom_hat
                authors {
                    name
                    fullSlug
                    content
                }
                featured_title
                resume
                featured_image {
                    filename
                    alt
                }
                featured_vertical_image {
                    filename
                    alt
                }
            }
        }
    }
    EducationalarticleItems(first_published_at_lt:"${today}",sort_by: "first_published_at:desc", with_tag: $tag, per_page: $per_page, excluding_ids: $excluding_ids) {
        total
        items {
            id
            slug
            full_slug
            uuid
            first_published_at
            name
            tag_list
            content {
                hat
                custom_hat
                resume
                body
                featured_title
                featured_image {
                    filename
                    alt
                }
                featured_vertical_image {
                    filename
                    alt
                }
                authors {
                    fullSlug
                    name
                    content
                }
            }
        }
    }
    ArticleItems(
            sort_by: "first_published_at:desc"
            with_tag: $tag
            per_page: $per_page
            excluding_ids: $excluding_ids
        ) {
            total
            items {
                id
                slug
                first_published_at
                full_slug
                uuid
                name
                tag_list
                content {
                    hat
                    custom_hat
                    _uid
                    featured_title
                    featured_image {
                        filename
                        alt
                    }
                    featured_vertical_image {
                        filename
                        alt
                    }
                    resume
                    body
                }
            }
        }
        ProjectItems(
            sort_by: "first_published_at:desc"
            with_tag: $tag
            per_page: $per_page
            excluding_ids: $excluding_ids
        ) {
            total
            items {
            id
            slug
            full_slug
            first_published_at
            uuid
            name
            tag_list
            content {
                featured_image {
                    filename
                    alt
                }
                resume
                body
            }
        }
    }
}
`;

export function GetAllContent(tag, per_page, excluding_ids) {
    const [getQuery, { data: stories, loading, error }] = useLazyQuery(query, {
        variables: { tag, per_page, excluding_ids }
    });

    const educationArticles = stories?.EducationalarticleItems.items || [];
    const institutionalArticles = stories?.ArticleItems.items || [];
    const journalismNews = stories?.NewsItems.items || [];
    const projectItems = stories?.ProjectItems.items || [];

    const data = !loading
        ? [...educationArticles, ...institutionalArticles, ...journalismNews, ...projectItems]
              .sort((a, b) => Date.parse(b.first_published_at) - Date.parse(a.first_published_at))
              .splice(0, per_page)
        : [];

    return { getQuery, loading, error, data };
}
